import axios from "axios";
import { Observable } from "rxjs";
import config from "../../config/config";
import Cookie from "cookies-js";


export const Operator_service = {
    getProviderByType,
    getAllProvider,
    addProvider,
    removeProvider,
    editProvider,
    getProviderList,
    getUngroupProvider,
    getOperatorByType
};

function getProviderByType(type) {
    let typeRoute = type == 'broadband' ? 'BroadbandOperatorList' : 'MobileOperatorList'
    return Observable.create(observer => {
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc);
        axios.get(config.API_URL + "operator/" + typeRoute + "/?authorization=" + json_cookie.token)
        .then(response => {
            if (response.data.status === 200) {
                observer.next(response.data.data);
            } else {
                observer.error(response.data);
            }
            observer.complete();
        })
        .catch(error => {
            observer.error(error)
        });
    })
}

function getProviderList(type){
    let typeRoute = type == 'broadband' ? 'BroadbandOperatorList' : 'MobileOperatorList' 
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve,reject) => {
        axios.get(config.API_URL+"operator/"+typeRoute+"/?authorization="+json_cookie.token)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getAllProvider(filter) {
    return Observable.create(observer => {
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc);
        axios.get(config.API_URL + "operator/getAll/?authorization=" + json_cookie.token,{params: filter})
            .then(response => {
                if (response.data.status === 200) {
                    observer.next(response.data.data);
                } else {
                    observer.error(response.data);
                }
                observer.complete();
            })
            .catch(error => {
                observer.error(error)
            });
    })
}

function addProvider(data) {
    return Observable.create(observer => {
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc);
        axios.post(config.API_URL + "operator/Create/?authorization="+ json_cookie.token, data)
        .then(response => {
            if (response.data.status === 200) {
                observer.next(response.data.data);
            } else {
                observer.error(response.data);
            }
            observer.complete();
        })
        .catch(error => {
            observer.error(error);
        });
    });

}

function removeProvider(data) {
    return Observable.create(observer => {
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc);
        axios.post(config.API_URL + "operator/Remove/?authorization=" + json_cookie.token, { provider_id: data })
        .then(response => {
            if (response.data.status === 200) {
                observer.next(response.data.data);
            } else {
                observer.error(response.data);
            }
            observer.complete();
        }).catch(err => {
            observer.error(err)
        });
    })
}

function editProvider(data) {
    return Observable.create(observer => {
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc);
        axios.post(config.API_URL + "operator/Update/?authorization=" + json_cookie.token, data)
        .then(response => {
            if (response.data.status === 200) {
                observer.next(response.data.data);
            } else {
                observer.error(response.data);
            }
            observer.complete();
        }).catch(err => {
            observer.error(err)
        });
    })
}

function getUngroupProvider(){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "operator/GetUngroup/?authorization=" + json_cookie.token)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
 }

function getOperatorByType(filter){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "operator/getOperatorByType/?authorization=" + json_cookie.token, {params : filter})
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}